import { getApplicationFocus } from '@/shared/utils/focus-application';

let originalTitle;
let numberWarningsMessages = 0;

export const newEvent = () => {
  const applicationInFocus = getApplicationFocus();

  if (applicationInFocus) return;

  newAlertMessageTitle();
};

export const newAlertMessageTitle = () => {
  numberWarningsMessages++;
  setNewTitle(originalTitle, numberWarningsMessages);
};

const setNewTitle = (title, messages) => {
  document.title = `(${messages}) ${title}`;
};

export const setMessagesNotRead = (messagesNotRead) =>
  (numberWarningsMessages = messagesNotRead);

export const resetOriginalTitle = () => {
  document.title = originalTitle;
  setMessagesNotRead(0);
};

export default (() => {
  originalTitle = document.title;
})();
